import { render, staticRenderFns } from "./ReplyNewChildSupport.vue?vue&type=template&id=9d443aa6"
import script from "./ReplyNewChildSupport.vue?vue&type=script&lang=ts"
export * from "./ReplyNewChildSupport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports